/* Early Black Friday 2026 homepage banners: fade between photos every N seconds (no pause on hover), dots, swipe.
   In the theme editor, selecting a banner block shows it until it is deselected. */
(function () {
  function init(root) {
    root.querySelectorAll('[data-ebf-hs]:not([data-ebf-ready])').forEach(function (el) {
      el.setAttribute('data-ebf-ready', '');
      var slides = el.querySelectorAll('.ebf-hs__slide');
      var dots = el.querySelectorAll('.ebf-hs__dot');
      if (slides.length < 2) return;
      var i = 0, paused = false, delay = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000, timer;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function restart() { clearInterval(timer); timer = setInterval(function () { if (!paused && !document.hidden) go(i + 1); }, delay); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
      el.addEventListener('shopify:block:select', function (e) {
        var k = Array.prototype.indexOf.call(slides, e.target);
        if (k > -1) { paused = true; go(k); }
      });
      el.addEventListener('shopify:block:deselect', function () { paused = false; restart(); });
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); }
      }, { passive: true });
      restart();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
